<template>
    <div style="position:relative;">
        <transition enter-active-class="animated fadeIn"
                    leave-active-class="animated fadeOut">
            <div v-if="showPopup" class="openPopup" :style="{top:topPopup + 'px', right:rightPopup + 'px'}">
                <div class="openPopup__title">
                    <div class="openPopup__item">{{pairData[0].symbol}}</div>
                    <div class="openPopup__item"
                        :class="(pairData.side < 0) ? 'color-green' : 'color-red'">
                        {{(pairData.side < 0) ? 'BUY' : 'SELL'}}</div>
                    <div class="openPopup__item">{{$moneyf(sumVolume.volume)}}</div>
                    <div class="openPopup__item">{{$moneyf(averagePrice,2)}}</div>
                    <div class="openPopup__item openPopup__item-balance"
                        :class="(sumOfPL.plDepo < 0) ? 'color-red' : 'color-green'">$ {{$moneyf(sumOfPL.plDepo, 2)}}</div>
                    <div class="openPopup__item openPopup__item-percent"
                        :class="(sumOfPL.plPercent < 0) ? 'color-red' : 'color-green'">({{$moneyf(sumOfPL.plPercent,2)}}%)</div>
                    <div class="openPopup__item openPopup__item-percent"
                        :class="(sumOfPL.plPips < 0) ? 'color-red' : 'color-green'">{{$moneyf(sumOfPL.plPips,2)}} p</div>
                    <div class="openPopup__item openPopup__item-close icon-close" @click="closePopup"></div>
                </div>
                <div class="openPopup__wrap">
                    <div class="openPopup__data">
                        <div class="openPopup__data-equity">$ {{$moneyf(statistic.DailyRecords[statistic.DailyRecords.length - 1].EquityClose)}}</div>
                        <div class="openPopup__data-profitPercent"
                            :class = "(deltaEquity < 0) ? 'color-red' : 'color-green'">{{$pricef(deltaEquity)}}%</div>
                    </div>
                    <simple-chart
                        :symbol="pairData[0].symbol"
                        :chartWidth = "527"
                        :chartHeight= "244">
                    </simple-chart>
                </div>
            </div>
        </transition>
        <table>
            <tr class="statistica__open-position-item-dataWidget header_statistica__open-position-accordion">
                <td class="statistica__open-position-item-dataWidget-instrument">{{pairData[0].symbol}}</td>
                <td class="statistica__open-position-item-dataWidget-open-deal color-green">{{pairData.length}}</td>
                <td class="statistica__open-position-item-dataWidget-pl"
                    :class="(sumOfPL.plDepo < 0) ? 'color-red' : 'color-green'">{{$moneyf(sumOfPL.plDepo,2)}}</td>
                <td class="statistica__open-position-item-dataWidget-pl-percent"
                    :class="(sumOfPL.plPercent < 0) ? 'color-red' : 'color-green'">{{$moneyf(sumOfPL.plPercent,2)}}</td>
                <td class="statistica__open-position-item-dataWidget-pl-pips"
                    :class="(sumOfPL.plPips < 0) ? 'color-red' : 'color-green'">{{$moneyf(sumOfPL.plPips,2)}}</td>
                <td class="statistica__open-position-item-dataWidget-ico">
                    <i class="icon-profit color-green" @click="onClick($event)"
                        :class="hiddenIco ? 'openPopup__hidden' : ''"></i>
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import SimpleChart from "../profitability/sig-simple-chart"
export default {
    components: {
        "simple-chart":SimpleChart
    },
    data() {
        return {
            showPopup:false,
            topPopup:0,
            rightPopup:30,
            statistic:{}
        }
    },
    props : {
        pairData:{}
    },
    computed : {
        ...mapGetters ({
            getCropStat: 'accountstat/getCroppedStatBySymbol'
        }),
        percentOfLuckyDeals() {
            let deals = 0;
            for (let i = 0; i < this.pairData.length; i++)
            {
                if(this.pairData[i].resultDepo > 0)
                deals++;
            }
            let percentDeals = deals * 100 / this.pairData.length
            return Math.ceil(percentDeals);
        },
        sumOfPL() {
            let sum = {
                plDepo: 0,
                plPips:0,
                plPercent:0
            };
            if (typeof this.getCropStat('') === "undefined")
                return sum;
            for (let i = 0; i < this.pairData.length; i++) {
                sum.plDepo+=this.pairData[i].resultDepo;
                sum.plPips+=this.pairData[i].resultPoint;
                sum.plPercent+=this.pairData[i].resultDepo/this.getCropStat('').Summary.Equity*100
            }
            return sum;
        },
        sumVolume() {
            let volume = {
                buy:0,
                sell:0
            };
            let sumVolume = {
                volume:0,
                symbol:''
            };
            for(let i = 0; i < this.pairData.length; i++) {
                if(this.pairData[i].side === -1) {
                    volume.sell += this.pairData[i].volume
                }
                else {
                    volume.buy += this.pairData[i].volume
                }
            }
            if(volume.sell < volume.buy) {
                sumVolume.volume = volume.buy
                sumVolume.symbol = 'buy'
            }
            else {
                sumVolume.volume = volume.sell
                sumVolume.symbol = 'sell'
            }
            return sumVolume
        },
        averagePrice() {
            let averagePrice = {
                buy:0,
                sell:0
            }
            let sumPriceSell = 0;
            let sumPriceBuy = 0;
            let cntSell = 0;
            let cntBuy = 0;

            for(let i = 0; i < this.pairData.length; i++) {
                if(this.pairData[i].side === -1) {
                    sumPriceSell += this.pairData[i].priceEnter
                    cntSell++;
                }
                else {
                    sumPriceBuy += this.pairData[i].priceEnter
                    cntBuy++;
                }
            }
            averagePrice.sell = sumPriceSell/cntSell;
            averagePrice.buy = sumPriceBuy/cntBuy;
            if(this.sumVolume.symbol == 'buy')
            return averagePrice.buy
            else
            return averagePrice.sell
        },
        deltaEquity() {
            return (this.statistic.Summary.Equity - this.statistic.DailyRecords[0].EquityOpen) / this.statistic.Summary.Equity * 100;
        },
        hiddenIco(){
            return (this.pairData[0].symbol == 'EURJPY' || this.pairData[0].symbol == 'NZDUSD' || this.pairData[0].symbol == 'AUDUSD')
        }
    },
    methods : {
        onClick(e) {
            this.showPopup = !this.showPopup
            if((screen.height - e.screenY) < 294)
            this.topPopup = -254;
            //this.rightPopup = e.screenX;
        },
        closePopup() {
            this.showPopup = false;
        },
        setStatistic(symbol)
        {
            let stat = this.getCropStat(symbol);
            if (!stat) {
                return;
            }
            this.statistic = stat;
        }
    },
    created() {
        subscribeOnUpdate(this.$store, this.pairData[0].symbol, isFirstObtained => {

                this.setStatistic(this.pairData[0].symbol)

        });
        this.setStatistic(this.pairData[0].symbol)
    }
}

function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: `popup-chart-${symbol}`,
            handler: handler
        }
    });
}
</script>

<style lang="less" scoped>
table {
    width:100%;
}
.statistica__open-position {
    //width: 912px;
    background-color: #3D536B;
    display: block;
    color: #fff;
    border-radius: 4px;

    &-item {
        border-bottom: 1px solid #293546;
        position: relative;

        &-title {
            font-family: Arimo;
            font-size: 13px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 3;
            letter-spacing: 0.4px;
            text-transform: uppercase;
            padding: 0 12px;
        }

        &-subtitle {
            font-family: Arimo;
            font-size: 11px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 3.64;
            letter-spacing: 0.4px;
            color: #adc7e1;
            text-transform: uppercase;
            display: flex;

            &-instrument {
                width: 152px;
                padding-left: 12px;
                box-sizing: border-box;
            }

            &-open-deal {
                width: 160px;
            }

            &-licky-deal {
                width: 142px;
                text-align: right;
            }

            &-pl {
                width: 140px;
                padding-right: 12px;
                text-align: right;
                box-sizing: border-box;
            }

            &-pl-percent {
                width: 88px;
                padding-right: 12px;
                text-align: right;
                box-sizing: border-box;
            }

            &pl-pips {
                width: 88px;
                padding-right: 12px;
                text-align: right;
                box-sizing: border-box;
            }

            maxdd {
                width: 88px;
                padding-right: 12px;
                text-align: right;
                box-sizing: border-box;
            }
        }
    }
}
.statistica__open-position-item-dataWidget {
    font-family: Arimo;
    font-size: 13px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.5;
    letter-spacing: 0.4px;
    text-align: left;
    color: #ffffff;
    outline: none;
    position: relative;
    cursor: pointer;
    background:#3D536B;
    display: flex;
    justify-content: space-between;
}
.statistica__open-position-item-dataWidget-pl {
    width: 135px;
    //padding-right: 12px;
    text-align: right;
    box-sizing: border-box;
}

.statistica__open-position-item-dataWidget-pl-percent {
    width: 135px;
    //padding-right: 12px;
    text-align: right;
    box-sizing: border-box;
}

.statistica__open-position-item-dataWidget-pl-pips {
    width: 135px;
    //padding-right: 12px;
    text-align: right;
    box-sizing: border-box;
}

.statistica__open-position-item-dataWidget-instrument {
    width: 152px;
    padding-left: 12px;
    box-sizing: border-box;
}

.statistica__open-position-item-dataWidget-open-deal {
    width: 160px;
    //padding-left: 12px;
    box-sizing: border-box;
    text-align: left;
    color: #293546;
/*background: url('/img/progressbar_1.png') no-repeat;
background-size: 32% 100%;*/
}

.statistica__open-position-item-dataWidget-ico {
    box-sizing: border-box;
    color: #718da8;
    width:23px;

    &:hover {
        color:#fff;
    }
}

.openPopup {
    background-color: #3d536b;
    border-radius: 4px;
    width: 527px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
    position:absolute;
    z-index: 1;
    &__data {
        position: absolute;
        padding-left: 12px;
        padding-top: 8px;
        &-equity {
            font-family: Arimo;
            font-size: 16px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1;
            letter-spacing: normal;
            color: @colors[green];
        }
        &-profitPercent {
            font-family: Arimo;
            font-size: 14px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.54;
            letter-spacing: normal;
        }
    }
    &__title {
        display: flex;
        justify-content: flex-start;
        border-bottom: 1px solid #374b62;
    }
    &__item {
        font-family: Arimo;
        font-size: 13px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 3.08;
        letter-spacing: 0.4px;
        text-align: left;
        color: #ffffff;
        margin-left: 12px;
        &-balance {
            color: @colors[green];
        }
        &-percent {
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            color: #0fd7b7;
        }
        &-close {
            align-self: center;
            margin-left: auto;
            margin-right: 12px;
            color: #718da8;
            cursor: pointer;
            font-size: 24px;
            line-height: 1;
            &:hover {
               color: #fff;
            }
        }
    }
    &__wrap {
        padding-top: 5px;
        position: relative;
    }
    &__hidden {
        visibility: hidden;
    }
}
</style>
